export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Lunes_banner.71c94423.png";